module.exports = __webpack_public_path__ + "static/portfolio-1-accf34016dfe2c9f4c6a22de9fb34a0f.jpg";